import React, { useEffect, useState } from "react";
import moment from "moment";
import OptOutModal from "./OptOutModal";
import MoreInfoHistoryPopUp from "./MoreInfoHistoryPopUp/MoreInfoHistoryPopUp";
import { FormattedMessage, useIntl } from "react-intl";
import StaticTable from "../StaticTable/StaticTable";
import Tooltip from "../Tooltip/Tooltip";
import DateToolTip from "../DateToolTip/DateToolTip";
import useHover from "../../hooks/useHover";
import { useDispatch } from "react-redux";
import HeaderWithTooltip from "../StaticTable/HeaderWithTooltip";
const LegitimateInterest = ({ refresh, details, loading, setLoading }) => {
  const intl = useIntl();
  const [liData, setliData] = useState([]);
  const dispatch = useDispatch();
  const [optOutOpen, setOptOutOpen] = useState(false);
  const [optOutRowData, setOptOutRowData] = useState();
  const [selectedLI, setSelectedLI] = useState();
  const [isProfileHistoryOpen, setIsProfileHistoryOpen] = useState(false);
  const { handleMouseEnter, handleMouseLeave, hoveredData, ishovered } =
    useHover();
  const [isAnyPurposeActive, setIsAnyPurposeActive] = useState(false);

  const getliData = async () => {
    try {
      if (Array.isArray(details?.data_processing_authorizations)) {
        const allData = details?.data_processing_authorizations;
        const legitimateInterest = Object.groupBy(
          allData,
          (allData) => allData.initial_legal_basis
        );
        setliData(legitimateInterest.legitimate_interest || []);
        setIsAnyPurposeActive(
          legitimateInterest?.legitimate_interest?.some(
            (item) => item.status == "Active"
          )
        );
      } else setliData([]);
    } catch (error) {}
  };
  useEffect(() => {
    if (
      details?.digital_identity?.type &&
      details?.digital_identity?.value &&
      details?.digital_identity?.controller_code &&
      details?.digital_identity?.customer_scope
    )
      getliData();
  }, [details]);
  const onCallback = () => {
    setLoading(true);
    setTimeout(refresh, "3000");
  };

  const columns = [
    {
      header: intl.formatMessage({
        id: "id.label.processing-purpose",
        defaultMessage: "Processing Purpose",
      }),
      accessorKey: "global_purpose",
    },
    {
      header: intl.formatMessage({
        id: "label.status",
        defaultMessage: "Status",
      }),
      accessorKey: "status",
      cell: function render(row) {
        // if (row?.row.original?.status === "Inactive") setIsClicked(true);
        // else setIsClicked(false);
        return (
          <span
            className={
              row?.row.original?.status === "Active"
                ? `text-active`
                : `text-inactive`
            }
          >
            {row?.row.original?.status}
          </span>
        );
      },
    },
    {
      header: intl.formatMessage({
        id: "label.status-reason",
        defaultMessage: "Status Reason",
      }),
      accessorKey: "status_reason",
    },
    {
      header: (
        <HeaderWithTooltip tooltipText="Value based on the Time Zone setting in the Configurations">
          <Tooltip position="right" text={"Date format: DD.MM.YYYY"}>
            <span>
              {intl.formatMessage({
                id: "label.capture-date",
                defaultMessage: "Capture Date",
              })}
            </span>
          </Tooltip>
        </HeaderWithTooltip>
      ),
      accessorKey: "capture_date",

      cell: (info) => {
        const value = info.getValue();
        if (value === null) {
          return "N/A";
        }
        if (moment(value).isValid()) {
          return moment(value).format("DD.MM.YYYY");
        }
        return "Invalid Date";
      },
    },
    {
      header: (
        <HeaderWithTooltip tooltipText="Value based on the Time Zone setting in the Configurations">
          <Tooltip position="right" text={"Time format: HH:MM"}>
            <span>
              {intl.formatMessage({
                id: "label.capture-time",
                defaultMessage: "Capture Time",
              })}
            </span>
          </Tooltip>
        </HeaderWithTooltip>
      ),
      accessorKey: "capture_time",

      cell: (info) => {
        const value = info.getValue();
        if (value === undefined || value === null || value === "") {
          return "N/A";
        }
        if (moment(value, "HH:mm:ss.SSS", true).isValid()) {
          return (
            <span className="pe-1">
              {moment(value, "HH:mm:ss.SSS").format("HH:mm")}
            </span>
          );
        }
        return "Invalid Date";
      },
    },
    {
      header: intl.formatMessage({
        id: "label.capture-source",
        defaultMessage: "Capture Source",
      }),
      accessorKey: "capture_source",
    },
    {
      header: () => {
        return (
          <Tooltip position="right" text={"Date format: DD.MM.YYYY"}>
            <span className="pe-1">
              {intl.formatMessage({
                id: "label.expiry-date",
                defaultMessage: "Expiry Date",
              })}
            </span>
          </Tooltip>
        );
      },
      accessorKey: "expiry_date",

      cell: (info) => {
        const value = info.getValue();
        if (value === null || value == undefined) {
          return "N/A";
        }
        if (moment(value)?.isValid()) {
          return moment.utc(value).local().format("DD.MM.YYYY");
        }
        return "Invalid Date";
      },
    },
    {
      header: () => {
        return (
          <Tooltip position="right" text={"Date format: DD.MM.YYYY"}>
            <span className="pe-1">
              {intl.formatMessage({
                id: "label.last-status-change-date",
                defaultMessage: "Last Status Change",
              })}
            </span>
          </Tooltip>
        );
      },
      accessorKey: "last_status_change_datetime",

      cell: (info) => {
        const value = info.getValue();
        if (value === null) {
          return "N/A";
        }
        if (moment(value).isValid()) {
          return (
            <div
              onMouseEnter={() => handleMouseEnter(value)}
              onMouseLeave={handleMouseLeave}
            >
              <span className="pe-1">
                {moment.utc(value).local().format("DD.MM.YYYY HH:mm")}
              </span>
              <DateToolTip ishovered={ishovered} hoveredData={hoveredData} />
            </div>
          );
        }
        return "Invalid Date";
      },
    },
    {
      header: intl.formatMessage({
        id: "label.collector-email",
        defaultMessage: "Collector Email",
      }),
      accessorKey: "collector_email",
      cell: (info) => {
        const value = info.getValue();
        if (value === null) {
          return "N/A";
        } else {
          return value;
        }
      },
    },
    {
      header: intl.formatMessage({
        id: "label.action",
        defaultMessage: "Action",
      }),
      accessorKey: "actions",
      cell: ({ row }) => {
        const status = row.getValue("status");
        return status === "Active" ? (
          <button
            className="btn btn-danger border-danger"
            onClick={(e) => {
              e.stopPropagation();
              setOptOutOpen(true);
              setOptOutRowData(row?.original);
            }}
          >
            OPT OUT
          </button>
        ) : null;
      },
    },
  ];
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 col-lg-12 px-0">
            <div className="custom-border">
              <div className="d-flex justify-content-end align-items-center search-bar-container px-3 py-2">
                {isAnyPurposeActive && (
                  <button
                    id="create-new-person"
                    className="btn btn-danger bg-danger-subtle text-danger border-danger-subtle"
                    onClick={() => {
                      // setIsClicked(true);
                      setOptOutOpen(true);
                      setOptOutRowData({
                        deactivate_all_li: true,
                      });
                    }}
                  >
                    <FormattedMessage
                      id="id.label.optout-form-all"
                      defaultMessage="OPT OUT FROM ALL"
                    />
                  </button>
                )}
              </div>
              <StaticTable
                columns={columns}
                data={liData}
                customClass={"legitimate-interest"}
                defaultErrorMessage={"No DPA records found"}
                messageId={"id.cp-li.table.no-dpa-records"}
                loading={loading}
                setIsProfileHistoryOpen={setIsProfileHistoryOpen}
                setSelectedConsent={setSelectedLI}
              />
            </div>
          </div>
        </div>
      </div>
      <MoreInfoHistoryPopUp
        isProfileHistoryOpen={isProfileHistoryOpen}
        setIsProfileHistoryOpen={setIsProfileHistoryOpen}
        setSelectedData={setSelectedLI}
        digitalIdentity={details?.digital_identity}
        history={details?.history?.[selectedLI?.global_purpose]}
        historyInfo={selectedLI}
      />
      <OptOutModal
        open={optOutOpen}
        setOpen={setOptOutOpen}
        data={optOutRowData}
        getList={onCallback}
        isLi={true}
        userDetails={{ ...details?.digital_identity }}
      />
    </>
  );
};

export default LegitimateInterest;
